import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router";

import {
  parseSelectedSitesFromSearch,
  replaceSelectedSitesInParams,
} from "./selectedSitesHelper";

const EMPTY_PATHS: readonly string[] = [];

/**
 * Clears selected-site query parameters on routes that must not retain a
 * selected-site context. Site selection itself is URL-backed.
 */
export function useSelectedSitesQuerySync({
  clearSelectedOnPaths = EMPTY_PATHS,
}: {
  clearSelectedOnPaths?: readonly string[];
} = {}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();
  const currentSearch = searchParams.toString();

  useEffect(() => {
    const routeSites = parseSelectedSitesFromSearch(currentSearch);
    if (!clearSelectedOnPaths.includes(pathname) || routeSites.length === 0) {
      return;
    }

    setSearchParams((params) => replaceSelectedSitesInParams(params, []), {
      replace: true,
    });
  }, [clearSelectedOnPaths, currentSearch, pathname, setSearchParams]);
}
